import { ChildForm, ChildFormProps } from '../../ChildForm';
import { ConditionalFormInput, ConditionalFormInputProps } from '../ConditionalFormInput';

export type ConditionalChildFormProps<TData extends object> = Omit<
  ConditionalFormInputProps<Partial<TData>>,
  'initialYesValue'
> &
  Pick<ChildFormProps<TData>, 'schema' | 'config' | 'showErrors'>;

export const ConditionalChildForm = <TData extends object>({
  schema,
  config,
  showErrors,
  ...props
}: ConditionalChildFormProps<TData>) => {
  const { value, disabled, onChange } = props;

  const isTrue = typeof value === 'object';

  return (
    <ConditionalFormInput {...props} initialYesValue={{}}>
      {isTrue && (
        <ChildForm
          schema={schema}
          config={config}
          value={value}
          disabled={disabled}
          showErrors={showErrors}
          onChange={onChange}
        />
      )}
    </ConditionalFormInput>
  );
};
